import React from 'react';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdEdit as EditIcon } from 'react-icons/md';

export const RenderEscalationRule = ({ items, onEdit, onDelete, disabled }) => {
  return (
    <div>
      {items.map((item, index) => {
        const name = item.name;
        return (
          <div
            id="mobile_card"
            key={index}
            style={{
              paddingBottom: '0px',
              textTransform: 'capitalize',
              maxWidth: '500px',
              margin: 'auto',
            }}
          >
            {!disabled && onDelete && (
              <IconButton
                style={{ float: 'right', padding: '0px', height: '1px' }}
                onClick={() => onDelete(index)}
              >
                <DeleteIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            {!disabled && onEdit && (
              <IconButton
                style={{ float: 'right', padding: '0px', marginRight: '25px', height: '1px' }}
                onClick={() => onEdit(index)}
              >
                <EditIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            <div className="row">
              <h4 style={{ float: 'left' }}>{name}</h4>
            </div>
            <div className="row">
              <p style={{ float: 'left', textTransform: 'lowercase' }}>
                {renderTimeOrDay(item.escalation_time)}
              </p>
            </div>

            <div className="row">
              <h5 style={{ float: 'left' }}>Assigned to:</h5>
            </div>
            <div className="row">{renderListOfAgents(item.agents)}</div>
          </div>
        );
      })}
    </div>
  );
};

function renderListOfAgents(escalationAgents) {
  if (!escalationAgents) return null;
  return escalationAgents.map((agentMultiSelect) => (
    <p style={{ textAlign: 'left' }}> {agentMultiSelect.label} </p>
  ));
}

function renderTimeOrDay(timeOrDay) {
  if (timeOrDay < 1) {
    return `${Math.round(timeOrDay * 24)} hours after ticket creation`;
  }

  return `${timeOrDay} days after ticket creation`;
}
